import React, { forwardRef } from "react";
import { cn } from "../../lib/utils";

const Input = forwardRef(
  ({ className, label, error, type = "text", ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block font-sans text-sm font-medium text-ink-muted mb-2">
            {label}
          </label>
        )}
        <input
          type={type}
          ref={ref}
          className={cn(
            // Base styles
            "w-full h-12 px-4",
            "font-body text-ink text-base",
            "bg-paper-dark/50",
            "border-b-2 border-border",
            "transition-all duration-300",
            // Focus state - gold underline
            "focus:outline-none focus:border-gold focus:bg-paper",
            // Placeholder
            "placeholder:text-ink-light placeholder:font-sans",
            // Error state
            error && "border-red-500 focus:border-red-500",
            // Disabled
            "disabled:opacity-50 disabled:cursor-not-allowed",
            className
          )}
          {...props}
        />
        {error && (
          <p className="mt-2 text-sm text-red-600 font-sans">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export { Input };
